var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5C11.6716 5 11 5.63093 11 6.40922V13.5293C11 13.9734 11.5952 14.1695 11.8904 13.8228L13 12.5671H19.5C20.3284 12.5671 21 11.9362 21 11.1579V6.40922C21 5.63093 20.3284 5 19.5 5H12.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5C3 3.34315 4.34315 2 6 2H14C15.1104 2 16.0799 2.6033 16.5987 3.5H12.5C10.9327 3.5 9.5 4.71566 9.5 6.40922V13.5293C9.5 14.5161 10.1835 15.1726 10.865 15.3972C11.5379 15.619 12.4215 15.5009 13.0209 14.8087L13.6762 14.0671H17V19C17 20.6569 15.6569 22 14 22H6C4.34315 22 3 20.6569 3 19V5ZM6.25 19C6.25 19.4142 6.58579 19.75 7 19.75H13C13.4142 19.75 13.75 19.4142 13.75 19C13.75 18.5858 13.4142 18.25 13 18.25H7C6.58579 18.25 6.25 18.5858 6.25 19Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileChat);
export default __webpack_public_path__ + "static/media/mobile-chat.6d5e43d8d07269b22a6a5938486769dd.svg";
export { ForwardRef as ReactComponent };